import { z } from "zod";
export const LogoStatus = {
    MISSING: "MISSING",
    DOES_NOT_MATCH_BRAND: "DOES NOT MATCH BRAND",
    IS_NOT_LEGIBLE: "IS NOT LEGIBLE",
    TAGLINE_NEEDS_TO_BE_REMOVED: "TAGLINE NEEDS TO BE REMOVED",
    PHONE_NUMBER_NEEDS_TO_BE_REMOVED: "PHONE NUMBER NEEDS TO BE REMOVED",
    IT_IS_TOO_SMALL_OR_NOT_LEGIBLE: "IT IS TOO SMALL OR NOT LEGIBLE",
    BACKGROUND_NEEDS_TO_BE_REMOVED: "BACKGROUND NEEDS TO BE REMOVED",
    APPROVED: "APPROVED",
};
export const verificationAddressSchema = z.object({
    found_on: z.string(),
    address_street: z.string(),
    address_street2: z.string(),
    address_city: z.string(),
    address_region: z.string(),
    address_postal_code: z.string(),
});
//# sourceMappingURL=types.js.map